import type { ReactNode } from 'react';

import { Field } from '@/components/ui';

/**
 * Campo do formulário de caso sobre o primitivo `Field` (E54.F7.T02).
 *
 * O `inputCls` local saiu: altura, respiro, foco e estado de erro dos controles
 * são do pacote (`Input`/`Select`/`Textarea`), e mantê-los aqui produzia um
 * segundo dialeto do mesmo campo.
 *
 * O que continua local é uma coisa só: o `data-testid` do erro (`<id>-error`),
 * que as suítes de `/casos/novo` e do passo Caso do wizard usam para provar a
 * validação. Ele viaja como nó dentro da mensagem, sem obrigar o primitivo
 * compartilhado a conhecer um detalhe de suíte.
 */
export interface FieldProps {
  id: string;
  label: string;
  hint?: string | undefined;
  required?: boolean | undefined;
  error?: string | undefined;
  colSpan?: 'full' | undefined;
  children: ReactNode;
}

export function CasoField({ id, label, hint, required, error, colSpan, children }: FieldProps) {
  return (
    <Field
      htmlFor={id}
      label={label}
      {...(hint !== undefined ? { description: hint } : {})}
      {...(required === true ? { required: true } : {})}
      {...(error !== undefined ? { error: <span data-testid={`${id}-error`}>{error}</span> } : {})}
      {...(colSpan === 'full' ? { className: 'sm:col-span-2' } : {})}
    >
      {children}
    </Field>
  );
}
